export default {
  // 描述文案(不具有通用性的文字)
  messages: {
    confirmDelete: '确认执行删除?',
    confirmSubmit: '确认执行提交？',
    confirmAction: '确认执行{action}?',
    confirmVoidBill: '确认要作废所选单据吗?',
    confirmCancelVoidBill: '确认要取消作废所选单据吗?',
    noDataProcess: '没有需要处理的数据',
    mergeSubmit: '当前类型对象的多行同时提交将产生数据“合并”的特殊功能。\\n\\n您确认要执行此特殊功能?\\n\\n（选择“取消”如果您尚不了解所谓“合并”的意义，并查看有关帮助以明确）',
    switchEditInterfaceFirst: '请先切换到修改界面',
    switchEditInterface: '切换到修改界面',
    selectLessData: '请选择少于20行的数据，以保证客户端响应速度!',
    modifySelectRow: '修改选中行',
    modifyResult: '修改结果集',
    copyBill: '复制单据',
    switchReadOnlyInterface: '切换到只读界面',
    selectSummaryTemplate: '请在查询栏选择汇总表模板',
    notDefineSummaryTemplate: '当前表没有定义汇总表模板',
    mustDataType: '必须是日期型',
    mustDigital: '必须是数字型',
    clickClearSetting: '点击清除当前条件设置',
    tickToConfirm: '请在要选择的行首打勾确认!',
    reenterReport: '当前操作界面非报表界面布局，请点击报表中心标签页重新进入报表模块后再试',
    collectionSelected: '该集合已被选择',
    collectionExcluded: '该集合已被排除',
    noPermissionToAccess: '用户无权限访问',
    moreFilters: '更多筛选',
    addCondition: '添加条件',
    viewSelectedResults: '查看选中结果',
    pleaseEnterAgain: '请重新输入',
    uploadWarning: '注意：上传文件中，不要放置宏或图标，不要更改列的顺序，数据中不要使用公式。',
    downloadTemplateRemark: '下载模版',
    fileSizeTip: '文件最大',
    colorSizeSave: '颜色尺寸保存',
    saveAsTemplate: '保存为模板',
    originalWarehouse: '原始店仓',
    targetWarehouse: '目标店仓',
    VIPType: 'VIP类型',
    selectedData: '已选中{total}条数据',
  },
  // 具有通用性的文案
  tips: {
    serverProcessing: '服务器处理中',
    categoryNavigation: '分类导航',
    systemMaintenance: '系统维护',
    operationTimeout: '操作超时',
    noPermission: '没有权限',
    abnormal: '异常',
    report: '报表',
    statistics: '统计',
    printWithTemplate: '套打',
    shortMessage: '短信',
    dialog: '对话框',
    hasBeenSelected: '已被选择',
    hasBeenExcluded: '已被排除',
    notify: '通知',
    priority: '优先级',
    sendTime: '发送时间',
    allNotifications: '全部通告',
    cancelVoid: '取消作废',
    more: '更多',
    copyPermission: '复制权限',
    notEmpty: '不能为空',
    hiddenColumn: '隐藏列',
    noData: '暂无数据',
    all: '全部',
    queryCondition: '查询条件',
    filterCondition: '筛选条件',
    filterResults: '筛选结果',
    color: '颜色',
    size: '尺寸',
    templateName: '模板名称',
    sourceTable: '源表表名',
    targetTable: '目标表名',
    targetDescription: '目标描述',
    phone: '手机号',
    sex: '性别',
    male: '男',
    female: '女',
    secret: '保密',
    region: '地区',
    yes: '是',
    no: '否',
    frequency: '次',
    yuan: '元',
    one: '一个',
    number: '编号',
    loading: '加载中',
    fullscreen: '全屏',
    exitFullscreen: '退出全屏',
    today: '今天',
    month: '月',
    day: '日',
    festival: '节日',
    notFestival: '非节日',
    yesterday: '昨天',
    allow: '允许',
    condition: '条件',
    attachment: '附件',
    uploadAttachment: '上传附件',
    name: '名称',
    quantity: '数量',
    unfold: '展开',
    fold: '收起',
    operation: '操作',
    point: '分'
  },
  feedback: {
    alert: '提示',
    warning: '警告',
    error: '错误',
    success: '成功',
    collectionSuccess: '收藏成功',
    collectionFailed: '收藏失败',
    unfavoriteSuccessfully: '取消收藏成功',
    failedToUnfavorite: '取消收藏失败',
    selected: '已选中',
    saveSuccess: '保存成功'
  },
  actions: {
    globalSearch: '全局检索',
    selectAll: '全选',
    clear: '清空',
    match: '匹配',
    exclude: '排除',
  },
  buttons: {
    print: '打印',
    back: '返回',
    bulkSubmission: '批量提交',
    batchEdit: '批量修改',
    import: '导入',
    export: '导出',
    add: '新增',
    save: '保存',
    delete: '删除',
    deleteDetails: '删除明细',
    cancelSubmission: '取消提交',
    submit: '提交',
    refresh: '刷新',
    batchAdd: '批量添加',
    copy: '复制',
    invalid: '作废',
    reset: '重置',
    filter: '筛选',
    cancel: '取消',
    confirm: '确认',
    close: '关闭',
    modify: '修改',
    find: '搜索',
    selectFile: '选择文件',
    search: '查询',
    exit: '退出',
    download: '下载'
  },
  // 表单(具有通用性的文案)
  form: {
    inputPlaceholder: '请输入',
    selectPlaceholder: '请选择',
  },
  // table文件下.vue
  table: {
    index: '序号',
    summation: '合计',
    total: '总计',
    boxNumber: '箱号',
    specification: '规格',
    deleteBoxNumber: '删除箱号',
    boxlessScanning: '无箱扫描',
    viewLog: '查看日志',
    enterQueryContent: '请输入查询内容',
    selectDeleteDetail: '请选择要删除的明细'
  },
  // advancedSearch.vue
  advancedSearch: {
    infoFiltering: '信息筛选',
    enterComplete: '请填写完整',
    selectedCondition: '已选条件',
    advancedSearch: '会员高级搜索',
    baseInfo: '基础信息',
    cardNumber: '会员卡号',
    typeOrLevel: '会员类型/等级',
    cardDate: '开卡日期',
    availablePoints: '可用积分',
    followAccount: '是否关注公众号',
    notFollowed: '未关注',
    followed: '已关注',
    unfollowed: '已取关',
    wxTiedToCard: '微信小程序是否绑卡',
    wxCardTiedCard: '微信会员卡是否绑卡',
    taobaoCard: '淘宝是否绑卡',
    memberLabel: '会员标签',
    consumptionAttr: '消费属性',
    lastPurchaseDate: '最近一次消费日期',
    consumptionAmount: '累计消费金额',
    consumptionNumber: '消费次数',
    associateRate: '连带率',
    averageCustomerPrice: '平均客单价',
    lifeCycle: '生命周期',
    newOldMember: '新老会员',
    newMember: '新会员',
    oldMember: '老会员',
    activityLevel: '活跃程度',
    activeMember: '活跃会员',
    inactiveMember: '不活跃会员',
    sleepingMember: '沉睡会员',
    lostMember: '流失会员',
    templateIsRequired: '模板名称不能为空',
    searchSuccessful: '搜索成功'
  },
  // serachComponent文件夹下所有.vue
  searchComponent: {
    matchedMatch: '已匹配到{num}位会员',
    pleaseImport: '请导入',
    importSuccess: '导入成功{msg}位',
    selectMore: '请选择一种或多种',
    selectMemberType: '请选择会员类型',
    selectMemberLevel: '请选择会员等级',
    moreOr: '多个或',
    addTag: '请添加标签',
    selectTag: '选择标签',
    fullDateFormat: 'yyyy 年 MM 月 dd 日',
    startDate: '开始日期',
    endDate: '结束日期',
    toDate: '(含）至',
    lastWeek: '最近一周',
    lastMonth: '最近一个月',
    lastThreeMonths: '最近三个月',
    to: '至',
    selectCumulativeMonth: '请选择累计月份',
    grandTotal: '累计',
    nearlyMonths: '近{num}个月',
    cardShop: '开卡店仓',
    selectedItems: '已选中{num}条'
  },
  // elememt/tableobj.vue 
  tableobj: {
    clickUpload: '点击上传'
  },
  // tablelist/fkdialog.vue 
  fkdialog: {
    searchResult: '查询结果',
    multipleSelection: '弹框多选',
    recordExists: '该记录已在已选中列表中',
    onlySelectOne: '只能选取一条数据',
    modifyQuery: '查询数量已超过上限，请修改查询条件'
  },
  // tablelist/importDialog.vue 
  importDialog: {
    fileName: '文件名',
    exportLocation: '导出位置',
    waitImport: '数据正在导入中，请稍候',
    downError: '下载报错信息',
    dataError: '第{num}条记录报错',
    importFile: '请选择要导入的文件'
  },
  // custompage/crm/guideTagPop.vue
  guideTagPop: {
    tagClassification: '标签分类',
    enterContent: '请输入内容',
    labelSuccess: '贴标签成功'
  },
  // page文件夹下所有.vue 
  page: {
    packStandard: '读入装箱标准'
  },
  // calendaar.vue
  calendar: {
    January: '一月',
    February: '二月',
    March: '三月',
    April: '四月',
    May: '五月',
    June: '六月',
    July: '七月',
    August: '八月',
    September: '九月',
    October: '十月',
    November: '十一月',
    December: '十二月',
    sun: '日',
    one: '一',
    two: '二',
    three: '三',
    four: '四',
    five: '五',
    six: '六',
    seven: '七',
    eight: '八',
    nine: '九',
    ten: '十'
  },
  // datepicker文件夹下.vue
  datepicker: {
    selectDate: '请选择日期',
    selectDateTime: '请选择日期时间',
    selectTime: '请选择时间点',
    aWeekAgo: '一周前'
  },
  // dialog文件下screenDialog.vue 
  screenDialog: {
    setParams: '商品搜索页（可设置参数）'
  },
  // element文加下img.vue和img3.vue 
  img: {
    next: '下一张',
    defaultPicture: '默认图片',
    pictureUploadFormat: '上传图片只能是 JPG,PNG,GIF 格式!',
    pictureUploadSize: '上传图片大小不能超过 2MB!',
    deleteImg: '此操作将永久删除该图片, 是否继续?',
  },
  // element/ItemCol.vue 
  itemCol: {
    closeStatus: '结案状态',
    allowExcess: '是否允许超量',
    closed: '已结案'
  },
  // element/upload.vue 
  upload: {
    maximumFile: '最大允许上传10MB内的文件！',
    allowType: '允许上传的文件类型为：xls、xlsx、xlsm、doc、docx！',
    uploadLimit: '最多只能上传三个文件！'
  },
  // input文件下.vue 
  input: {
    storeCode: '店仓编码',
    storeName: '店仓名称',
    store: '店仓',
    userGroup: '用户组',
    productNumber: 'SPU编码',
    enterBarcode: '请输入SKU、SPU编码',
    matrixEntry: '矩阵录入',
    selectStore: '请选择店仓',
    addBarcode: '单条码新增成功',
    promotionCategories: '促销大类',
    promotionalClass: '促销中类',
    category: '所属大类',
    enterProductCode: '请输入SPU编码'
  },
  // report文件下.vue
  report: {
    messageNotification: '信息提示',
    waitRequest: '正在处理请求，请稍等'
  },
  // views/custompage文件下.vue 
  custompage: {
    matchInLib: '匹配在库',
    matchAvailable: '匹配可用',
    shop: '门店',
    shipInStore: '发货在库',
    inStore: '在库',
    shipmentAvailable: '发货可用',
    available: '可用',
    receiptInStore: '收货在库',
    receiptAvailable: '收货可用',
    inventoryStatus: '彩色区为发货店仓库存情况',
    rowTotal: '行合计',
    enterDigit: '输入值不能大于{num}位数',
    barcodeNotExist: '该矩形框表示︰条码档案不存在该条码',
    hangzhouStore: '杭州店仓',
    matchSuccessfully: '匹配成功',
  },
  // jordanComponents文件下.vue
  jordanComponents: {
    uploadFile: '上传文件',
    overwriteNote: '覆盖原备注',
    appendNote: '追加到原备注',
    importFail: '导入失败'
  }
};
